import {decode as base64_decode, encode as base64_encode} from 'base-64';
import RootStore from './RootStore';
import { postApi } from '../components/Utility'
import {
  action,
  
  makeObservable,
  observable,
 
} from 'mobx';


class BlacklistPersonReportStore {
    blackListPersonReport=[]
  total=0
  loading=false
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
        blackListPersonReport: observable,
      total:observable,
      loading:observable,
      loadData:action,
     
    });
     this.rootStore = rootStore;
    
  }

  async loadData({offset,limit,companyId,vehicleId,fromDate,toDate}) {
    var postData = {"companyId":companyId,"vehicleId":vehicleId,"fromDate":fromDate,"toDate":toDate,"offset":offset,"limit":limit,"page":1}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=blacklist&a=getBlacklistFolderRecord", "postData="+base64Input);
    console.log("sim " ,response?.data?.data)
    this.blackListPersonReport =response?.data?.data?.blackListPersonReport
     this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }


  

  
  

}

export default BlacklistPersonReportStore;
